// 주간보고 — 주(週)는 그 주 월요일(KST) 'YYYY-MM-DD' 로 식별(weekKey).
// 회의 기본 일시 = 그 주 월요일 10:00 KST, 주별로 일시 변경(override) 가능.
// 작성 기간 = 직전 회의 당일 오후(13:00, 회의가 그보다 늦으면 회의 시작 1시간 뒤) ~ 해당 회의 시작 전.
const KST_MS = 9 * 3600 * 1000;
const DAY_MS = 86400 * 1000;
export const WEEKLY_STATUS_LABELS = { upcoming: '작성 전', writing: '작성 중', closed: '진행 완료' };
/** 날짜가 속한 주의 월요일(KST) 키 */
export function weekKeyOf(d) {
    const k = new Date(d.getTime() + KST_MS); // KST 벽시계를 UTC 필드로 읽음
    const dow = (k.getUTCDay() + 6) % 7; // 월=0 … 일=6
    return new Date(k.getTime() - dow * DAY_MS).toISOString().slice(0, 10);
}
export function addWeeks(key, n) {
    return new Date(Date.parse(`${key}T00:00:00Z`) + n * 7 * DAY_MS).toISOString().slice(0, 10);
}
/** 회의 일시 — 변경분이 있으면 그것, 없으면 월요일 10:00 KST */
export function meetingAt(key, overrides = {}) {
    const o = overrides[key];
    return o ? new Date(o) : new Date(Date.parse(`${key}T10:00:00+09:00`));
}
/** 작성 시작 — 직전 회의 당일 13:00 KST 와 직전 회의 +1시간 중 늦은 쪽 */
export function openAt(key, overrides = {}) {
    const prev = meetingAt(addWeeks(key, -1), overrides);
    const prevDayKst = new Date(prev.getTime() + KST_MS).toISOString().slice(0, 10);
    return new Date(Math.max(Date.parse(`${prevDayKst}T13:00:00+09:00`), prev.getTime() + 3600 * 1000));
}
export function weeklyStatus(key, overrides = {}, now = new Date()) {
    if (now.getTime() >= meetingAt(key, overrides).getTime())
        return 'closed';
    return now.getTime() >= openAt(key, overrides).getTime() ? 'writing' : 'upcoming';
}
/** 다가오는(아직 시작 전인) 회의의 주 — 지금 작성 대상 */
export function nextWeekKey(now = new Date(), overrides = {}) {
    let k = addWeeks(weekKeyOf(now), -1);
    while (now.getTime() >= meetingAt(k, overrides).getTime())
        k = addWeeks(k, 1);
    return k;
}
export const WEEKLY_ROLE_LABELS = { reporter: '보고자', receiver: '피보고자', none: '비보고자' };
/** 피보고자 메모 — 기존 주간회의 문서 하단의 업무진행·공지사항·참고용 */
export const WEEKLY_NOTE_SECTIONS = [
    { key: 'work', label: '업무진행', hint: '전사 사업·영업 진행 현황' },
    { key: 'notice', label: '공지사항', hint: '전 임직원 공지' },
    { key: 'ref', label: '참고용', hint: '공유·참고 사항' },
];
/** upn 의 구분 — 피보고자 > 비보고자 > 보고자(기본) */
export function weeklyRoleOf(upn, cfg) {
    const u = upn.toLowerCase();
    if (cfg.receivers.some((x) => x.toLowerCase() === u))
        return 'receiver';
    return cfg.excluded.some((x) => x.toLowerCase() === u) ? 'none' : 'reporter';
}
export const emptyWeeklyNotes = () => ({
    sections: { work: '', notice: '', ref: '' },
});
//# sourceMappingURL=weekly.js.map